import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize, take } from 'rxjs';
import { NotesApiService } from 'src/app/core/services/api/notes-api.service';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { NoteResponse } from '../../models/note.model';
import { MentionInputComponent } from '../mention-input/mention-input.component';

@Component({
  selector: 'app-create-note-modal',
  templateUrl: './create-note-modal.component.html',
  styleUrls: ['./create-note-modal.component.scss'],
})
export class CreateNoteModalComponent implements OnInit {
  @ViewChild('mentionInput') mentionInput?: MentionInputComponent;

  isLoadingSubmit: boolean = false;
  addNoteForm!: FormGroup;
  note?: NoteResponse;
  mentionedUserIds: number[] = [];

  constructor(
    private fb: FormBuilder,
    protected dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private notesApiService: NotesApiService,
    private errHandle: ErrorHandlingService,
    private notificationService: NotificationsService
  ) {}

  ngOnInit(): void {
    this.note = this.dialogConfig.data.note;
    this.initForm();
  }

  initForm(): void {
    this.addNoteForm = this.fb.group({
      content: [this.note?.content || '', Validators.required],
      is_public: [this.note ? this.note?.is_public === 'public' : true],
    });
  }

  createNote(): void {
    const { model, model_id, isAgentMode } = this.dialogConfig.data;

    if (!model || !model_id) {
      return;
    }

    const formValue = this.addNoteForm.value;
    const payload: any = {
      content: formValue.content,
      is_public: formValue.is_public ? 1 : 0,
      is_claim_note: !!this.dialogConfig.data.is_claim_note,
      model,
      model_id,
      is_agent_note: !!isAgentMode,
    };

    // Add mentioned users if any
    if (this.mentionedUserIds.length > 0) {
      payload.mentioned_users = this.mentionedUserIds;
    }

    this.isLoadingSubmit = true;
    const request$ = this.note
      ? this.notesApiService.update(this.note.id, payload)
      : this.notesApiService.create(payload);

    request$
      .pipe(
        take(1),
        finalize(() => (this.isLoadingSubmit = false))
      )
      .subscribe({
        next: (res) => {
          this.notificationService.success('', res?.message);
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.errHandle.errorHandling(err);
        },
      });
  }

  onMentionedUsersChange(userIds: number[]): void {
    this.mentionedUserIds = userIds;
  }
}
